import { render } from "./TaskDot.vue?vue&type=template&id=40b4c772&scoped=true&ts=true"
import script from "./TaskDot.vue?vue&type=script&lang=ts"
export * from "./TaskDot.vue?vue&type=script&lang=ts"

import "./TaskDot.vue?vue&type=style&index=0&id=40b4c772&lang=less"
import "./TaskDot.vue?vue&type=style&index=1&id=40b4c772&scoped=true&lang=less"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b4c772"]])

export default __exports__